import axios from 'axios';
import { bdmAppOrigin } from '../config/sfApiBase';

/**
 * Outlook / Microsoft Graph: all auth and Graph calls go through the Express server.
 * Never put MSGRAPH_CLIENT_SECRET (or REACT_APP_MSGRAPH_CLIENT_SECRET) in the frontend bundle.
 */
class OutlookService {
  constructor() {
    this.proxyBaseUrl = bdmAppOrigin();
    this.isTestMode = false;
    this.testEmailAddress = 'damian@purelocations.com.au';
  }

  setTestMode(enabled) {
    this.isTestMode = enabled;
    return this.isTestMode;
  }

  getTestMode() {
    return this.isTestMode;
  }

  async sendEmail(emailData, sendAsEmail) {
    const response = await axios.post(
      `${this.proxyBaseUrl}/api/msgraph/send-mail`,
      {
        to: emailData.to,
        cc: emailData.cc || undefined,
        bcc: emailData.bcc || undefined,
        subject: emailData.subject,
        body: emailData.body,
        sendAsEmail,
      },
      {
        headers: { 'Content-Type': 'application/json' },
        validateStatus: (status) => status >= 200 && status < 300,
      }
    );

    return response.status >= 200 && response.status < 300 && response.data?.success === true;
  }

  async composeEmail(emailData, ownerEmail) {
    if (!ownerEmail) {
      throw new Error('Owner email is required to send the email');
    }

    let emailToSend = emailData;

    if (this.isTestMode) {
      const originalRecipient = emailData.to;
      emailToSend = {
        ...emailData,
        to: this.testEmailAddress,
        subject: `[TEST MODE - Original: ${originalRecipient}] ${emailData.subject}`,
        body: `<div style="background-color: #f8d7da; color: #721c24; padding: 10px; margin-bottom: 15px; border: 1px solid #f5c6cb; border-radius: 4px;"><strong>TEST MODE</strong><br>Original Recipient: ${originalRecipient}<br>This is a test email that would normally be sent to the contact.</div>${emailData.body}`,
      };
    }

    return this.sendEmail(emailToSend, ownerEmail);
  }
}

const outlookService = new OutlookService();
export default outlookService;
